import { HairColorOption, Selector } from '../options';

export interface Props {
  maskID: string;
}

function makeColor(maskID: string, name: string, color: string) {
  const ColorComponent = () => (
    <g id="Skin/👶🏽-03-Brown" mask={`url(#${maskID})`} fill={color}>
      <g transform="translate(0.000000, 0.000000) " id="Color">
        <rect x="0" y="0" width="264" height="280" />
      </g>
    </g>
  );

  ColorComponent.displayName = name;
  return ColorComponent;
}

export default function HairColor({ maskID }: Props) {
  const Auburn = makeColor(maskID, 'Auburn', '#A55728');
  const Black = makeColor(maskID, 'Black', '#2C1B18');
  const Blonde = makeColor(maskID, 'Blonde', '#B58143');
  const BlondeGolden = makeColor(maskID, 'BlondeGolden', '#D6B370');
  const Brown = makeColor(maskID, 'Brown', '#724133');
  const BrownDark = makeColor(maskID, 'BrownDark', '#4A312C');
  const PastelPink = makeColor(maskID, 'PastelPink', '#F59797');
  const Blue = makeColor(maskID, 'Blue', '#000fdb');
  const Platinum = makeColor(maskID, 'Platinum', '#ECDCBF');
  const Red = makeColor(maskID, 'Red', '#C93305');
  const SilverGray = makeColor(maskID, 'SilverGray', '#E8E1E1');

  return (
    <Selector option={HairColorOption} defaultOption={BrownDark}>
      <Auburn />
      <Black />
      <Blonde />
      <BlondeGolden />
      <Brown />
      <BrownDark />
      <PastelPink />
      <Blue />
      <Platinum />
      <Red />
      <SilverGray />
    </Selector>
  );
}
